import React from "react";
import { API } from "../lib/brand";

/**
 * Renders a brand logo from the backend's clean PNG endpoint. The backend
 * thresholds the original JPEG (checkered background) and returns a true
 * transparent PNG, so no CSS filter / mix-blend tricks are needed.
 */
export default function BrandMark({
  variant = "knot",
  className = "",
  style = {},
  testid,
  alt,
}) {
  const url = `${API}/brand/${variant === "wordmark" ? "wordmark" : "knot"}.png`;
  const defaultAlt = variant === "wordmark" ? "Grá" : "Grá Celtic heart knot";
  return (
    <img
      src={url}
      alt={alt ?? defaultAlt}
      data-testid={testid}
      draggable="false"
      className={`object-contain select-none ${className}`}
      style={style}
    />
  );
}
